module.exports = __webpack_public_path__ + "img/red-level.d5426ff2.svg";